export const CONFIG = {
  productName: 'Boss.az',
  isProduction:
    process.env.NODE_ENV === 'production' ||
    process.env.VERCEL_ENV === 'production',
  authSessionCookieName: '_bossaz_session',
  protocol: process.env.BOSSAZ_PROTOCOL || 'https',
  host: process.env.BOSSAZ_HOST || 'boss.az',
  bugsnagApiKey: process.env.BUGSNAG_API_KEY || 'DO_NOT_SEND',
  contacts: {
    tel: '(012) 526-44-11',
    telUrl: 'tel:+994125264411',
    email: 'boss@boss.az',
    emailUrl: 'mailto:boss@boss.az',
    instagramLink: 'https://www.instagram.com/boss.az.official/',
    facebookLink: 'https://www.facebook.com/www.boss.az/',
    telegramLink: 'https://t.me/bossaz'
  },
  gtmContainerId: 'GTM-TT3NKM7',
  isAnalyticsEnabled:
    process.env.NODE_ENV === 'production' || process.env.GA_ENABLED === 'true',
  SSG_ROUTES: ['/login', '/reset-password', '/update-password', '/pages'],
  currentYear: new Date().getFullYear()
} as const;
